import { useQuery } from "react-query";
import { IBillingApiResponse } from "../types";
import { billingService, FETCH_RECURLY_DETAILS } from "../services";

export const useGetRecurlyDetails = () => {
  const { data, isLoading, isError } = useQuery<
    IBillingApiResponse | undefined
  >({
    queryKey: FETCH_RECURLY_DETAILS,
    queryFn: async () => await billingService.getRecurlyDetails(),
  });

  return { data, isLoading, isError };
};
